/**
 * Difference slider — horizontal carousel (pattern from achieve-section).
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function DifferenceSlider(root) {
    this.root = root;
    this.track = root.querySelector('[data-dds-track]');
    this.cards = root.querySelectorAll('[data-dds-card]');
    this.prevBtn = root.querySelector('[data-dds-prev]');
    this.nextBtn = root.querySelector('[data-dds-next]');
    this._onScroll = this.updateArrows.bind(this);
    this._onKeydown = this._handleKeydown.bind(this);
    this._onResize = this.updateArrows.bind(this);

    this.bind();
    this.updateArrows();
  }

  DifferenceSlider.prototype.bind = function () {
    var self = this;

    if (this.track) {
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('keydown', this._onKeydown);
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.scrollByCard(-1);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.scrollByCard(1);
      });
    }

    window.addEventListener('resize', this._onResize);
  };

  DifferenceSlider.prototype.destroy = function () {
    if (this.track) {
      this.track.removeEventListener('scroll', this._onScroll);
      this.track.removeEventListener('keydown', this._onKeydown);
    }
    window.removeEventListener('resize', this._onResize);
  };

  DifferenceSlider.prototype._handleKeydown = function (event) {
    if (!event) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.scrollByCard(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.scrollByCard(1);
    }
  };

  DifferenceSlider.prototype.getGap = function () {
    if (!this.track) return 14;
    try {
      return parseInt(window.getComputedStyle(this.track).gap, 10) || 14;
    } catch (e) {
      return 14;
    }
  };

  DifferenceSlider.prototype.getScrollAmount = function () {
    if (!this.track) return 0;
    var card = this.track.querySelector('[data-dds-card]');
    if (!card) return 0;
    return (card.offsetWidth || 0) + this.getGap();
  };

  DifferenceSlider.prototype.scrollByCard = function (direction) {
    if (!this.track) return;

    var amount = this.getScrollAmount();
    if (!amount) return;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (typeof this.track.scrollBy === 'function') {
      this.track.scrollBy({ left: direction * amount, behavior: behavior });
    } else {
      this.track.scrollLeft += direction * amount;
    }
  };

  DifferenceSlider.prototype.updateArrows = function () {
    if (!this.track) return;

    var maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;

    if (this.prevBtn) {
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
    }
  };

  function init(root) {
    if (!root || root.nodeType !== 1) return null;
    if (root.getAttribute('data-dds-init') === 'true') return root._differenceSlider || null;

    root.setAttribute('data-dds-init', 'true');
    var instance = new DifferenceSlider(root);
    root._differenceSlider = instance;
    return instance;
  }

  function destroy(root) {
    if (!root || root.nodeType !== 1) return;
    var instance = root._differenceSlider;
    if (instance && typeof instance.destroy === 'function') instance.destroy();
    delete root._differenceSlider;
    root.removeAttribute('data-dds-init');
  }

  function initAll(scope) {
    var container = scope && scope.nodeType === 1 ? scope : document;
    if (!container.querySelectorAll) return;
    var roots = container.querySelectorAll('[data-difference-slider]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function destroyAll(scope) {
    var container = scope && scope.nodeType === 1 ? scope : document;
    if (!container.querySelectorAll) return;
    var roots = container.querySelectorAll('[data-difference-slider]');
    for (var i = 0; i < roots.length; i++) destroy(roots[i]);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll(document);
  });
})();
